<script>
export default {
  methods: {
    filterMixin_company(item) {
      const isAGroup = item.companyType == 'G';

      if (isAGroup) {
        const foundGroup = this.enterprisesGroupSelect
          .find((group) => group.id == item.group);

        return foundGroup ? foundGroup.description : '';
      }

      const foundCompanies = this.enterprisesSelect.filter((enterprise) => {
        return item.group.some((itemEnterpriseId) => {
          return itemEnterpriseId == enterprise.id;
        });
      });

      const companyNames = foundCompanies.map((company) => company.name);

      return companyNames.join(', ');
    },
  },
};
</script>
